<template>
  <a-breadcrumb style="margin: 16px 0">
    <a-breadcrumb-item>贡献者</a-breadcrumb-item>
    <a-breadcrumb-item>概览</a-breadcrumb-item>
  </a-breadcrumb>
  <a-layout-content>
    <div class="radio-group">
      <div>项目维度：</div>
      <my-radio-group v-model="dimension" :optionMap="dimensionMap" :colorMap="colorMap" />
    </div>

    <contributor-overview-upper :dimension="dimension" :currentColor="currentColor" />

    <contributor-overview-days v-show="dimension === 'all'" />

    <ContributorOverviewTrend></ContributorOverviewTrend>
  </a-layout-content>
</template>

<script setup>
import { computed, ref } from 'vue';
import MyRadioGroup from '../components/MyRadioGroup.vue';
import ContributorOverviewUpper from './ContributorOverviewUpper.vue';
import ContributorOverviewDays from './ContributorOverviewDays.vue';
import ContributorOverviewTrend from './ContributorOverviewTrend.vue';

const dimensionMap = { all: '全部', master: '主干', sig: '孵化仓', tpc: 'TPC' };
const colorMap = { all: '#50A2FF', master: '#C27AFF', sig: '#05DF72', tpc: '#FF8904' };

const dimension = ref('all');
const currentColor = computed(() => colorMap[dimension.value] || '#d9d9d9');
</script>

<style scoped>
.radio-group {
  display: flex;
  width: 100%;
  margin-bottom: 16px;
  justify-content: flex-start;
  align-items: center;
}
</style>